import { type InputHTMLAttributes, forwardRef } from 'react';
import { Search, X } from 'lucide-react';
import clsx from 'clsx';

interface FgSearchProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> {
  onClear?: () => void;
}

/**
 * FullGerman Search — DNA §10.2.
 * Pill-shaped input with leading search icon and an inline clear button.
 */
export const FgSearch = forwardRef<HTMLInputElement, FgSearchProps>(function FgSearch(
  { onClear, value, className, ...props },
  ref,
) {
  const hasValue = Boolean(value);
  return (
    <div className={clsx('relative flex w-full items-center', className)}>
      <Search
        size={16}
        aria-hidden
        className="pointer-events-none absolute left-4 text-gray-500"
      />
      <input
        ref={ref}
        value={value}
        className={clsx(
          'h-12 w-full rounded-full border-none bg-gray-100 pl-11 pr-11 text-sm text-black placeholder:text-gray-500 transition-colors focus:bg-white focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-1',
        )}
        {...props}
      />
      {hasValue && (
        <button
          type="button"
          aria-label="Clear search"
          onClick={onClear}
          className="absolute right-3 rounded-full p-1 text-gray-500 hover:bg-gray-200 hover:text-black fg-anim-fast"
        >
          <X size={14} />
        </button>
      )}
    </div>
  );
});
